import { spacing, media } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
import { threeLarge } from "./gap.js";
const classNamePrefix = "umd-layout-grid-offset";
const threeColumn = objectWithClassName({
  ...threeLarge,
  className: [
    `${classNamePrefix}-three`,
    /** @deprecated Use 'umd-layout-grid-offset-three' instead */
    "umd-grid-gap-three-offset"
  ],
  "& > *": {
    alignSelf: "start",
    display: "grid",
    [`@media (${media.queries.desktop.min})`]: {
      minHeight: "400px"
    }
  },
  "& > *:first-child": {
    [`@media (${media.queries.desktop.min})`]: {
      marginTop: `${spacing["2xl"]}`
    }
  },
  "& > *:nth-child(2)": {
    [`@media (${media.queries.desktop.min})`]: {
      marginTop: `${spacing["8xl"]}`
    }
  },
  "& umd-element-stat": {
    [`@media (${media.queries.desktop.min})`]: {
      height: `100%`
    }
  }
});
export {
  threeColumn
};
//# sourceMappingURL=offset.js.map
